import { render, staticRenderFns } from "./SpecialOffers.vue?vue&type=template&id=a96fe6f2&scoped=true&"
import script from "./SpecialOffers.vue?vue&type=script&lang=js&"
export * from "./SpecialOffers.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOffers.vue?vue&type=style&index=0&id=a96fe6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96fe6f2",
  null
  
)

export default component.exports